import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

export const languagesOptions: Option[] = [
  {
    value: 'nl',
    label: t('languages.dutch')
  },
  {
    value: 'en',
    label: t('languages.english')
  }
];
